<template>
  <div>
    <b-row v-if="data && !isEmptySet">
      <b-col>
        <highcharts :key="hcKey" :options="chartOptions"></highcharts>
      </b-col>
    </b-row>
    <b-row class="mb-4" v-else>
      <b-col cols="12">
        <chart-not-available
          :full-page-loading="globalLoading"
          :active-loading="isLoading"
          :if-is-mop="false"
        ></chart-not-available>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { setChartMenuItemsLang } from '../../utils/formatter'
import ChartNotAvailable from '../MarketCompCharts/ChartNotAvailable'

export default {
  components: {
    ChartNotAvailable,
  },

  props: {
    data: {
      required: true,
    },
    chartTitle: {
      type: String,
      default: '',
    },
    globalLoading: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loaderColor: {
      type: String,
      default: 'blue',
    },
    isEmptySet: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hcKey: 0,
    }
  },

  computed: {
    chartOptions: function () {
      const instance = this
      return {
        lang: this.setOptions,
        boost: {
          seriesThreshold: 1,
          usePreAllocated: true,
        },
        plotOptions: {
          series: {
            turboThreshold: 0,
            cursor: 'pointer',
            events: {
              click: function (event) {
                instance.$emit('column-click', {
                  chartCategory: 'distribution-chart',
                  range: 'distribution_score_range',
                  isLastColumns: event.point.index === event.point.series.yData.length - 1,
                  min: event.point.x,
                  max: event.point.x2,
                })
              },
            },
          },
        },
        yAxis: {
          allowDecimals: false,
          showLastLabel: true,
          endOnTick: true,
          title: {
            text: this.$t('marketComparation.numberOfProducts'),
          },
        },
        chart: {
          zoomType: 'xy',
          backgroundColor: '#FFFFFF',
          margin: [50, 20, 50, 80],
          height: '42%',
        },
        tooltip: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: this.chartTitle,
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          allowDecimals: true,
          min: 0,
          max: 1,
          plotLines: [...this.productsUnderDistributionPlotLines, ...this.productsUnderTestingPlotLines],

          labels: {
            formatter: (val) => Math.round(val.value * 100) + '%' || 0,
          },
          title: {},
          showLastLabel: true,
          endOnTick: true,
        },
        series: [
          {
            type: 'histogram',
            baseSeries: 'distribution',
            column: {
              pointPlacement: 0.5,
            },
          },
          {
            type: 'scatter',
            data: [
              ...this.data.productsMarketSegment.map((el) => el.score),
              ...this.data.productsUnderTesting.map((el) => el.score),
              ...this.data.productsUnderDistribution.map((el) => el.score),
            ],
            id: 'distribution',
            visible: false,
          },
        ],
      }
    },

    setOptions() {
      this.hcKey += 1
      return setChartMenuItemsLang()
    },

    productsUnderTestingPlotLines() {
      return this.data.productsUnderTesting.map((el) => {
        return {
          color: '#EA633E',
          width: 2,
          zIndex: 5,
          value: el.score,
        }
      })
    },

    productsUnderDistributionPlotLines() {
      return this.data.productsUnderDistribution.map((el) => {
        return {
          color: '#F8DCB6',
          width: 2,
          zIndex: 4,
          value: el.score,
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
